import { readFromSessionStorage, writeToSessionStorage } from './localStorage';

const TRAFFIC_SOURCE_KEY = 'leora_traffic_source';

function toHostname(value: string): string | null {
  try {
    const url = value.includes('://') ? value : `https://${value}`;
    return new URL(url).hostname.replace(/^www\./i, '') || null;
  } catch {
    return null;
  }
}

export function captureTrafficSource(): void {
  if (readFromSessionStorage(TRAFFIC_SOURCE_KEY)) return;

  const referrerHost = toHostname(document.referrer);
  if (!referrerHost) return;

  const currentHost = window.location.hostname.replace(/^www\./i, '');
  if (referrerHost === currentHost) return;

  writeToSessionStorage(TRAFFIC_SOURCE_KEY, referrerHost);
}

export function getTrafficSource(): string | null {
  return readFromSessionStorage(TRAFFIC_SOURCE_KEY) ?? null;
}
